import { QUERY_KEY_MANAGEMENT_SEARCH_UNITS, QUERY_KEY_MANAGEMENT_SEARCH_UNITS_COUNT } from '@apps-common/apis/management/unit'
import { QUERY_KEY_GET_PINNED_UNITS_LIST } from '@apps-common/apis/portal/dash/get-dash-pinned-list'
import { QUERY_KEY_GET_DASH_RECENT_ACTIVATION_LIST } from '@apps-common/apis/portal/dash/get-dash-recent-activation-list'
import { QUERY_KEY_GET_DASH_RECENT_CANCELLED_LIST } from '@apps-common/apis/portal/dash/get-dash-recent-cancelled-list'
import { QUERY_KEY_GET_DASH_RECENT_PENDING_CANCEL_LIST } from '@apps-common/apis/portal/dash/get-dash-recent-pending-cancel-list'
import { QUERY_KEY_PORTAL_SEARCH_UNITS, QUERY_KEY_PORTAL_SEARCH_UNITS_COUNT } from '@apps-common/apis/portal/unit'
import { queryClient } from '@apps-common/lib'

import { QUERY_MANAGEMENT_GET_UNIT_ACTIVE } from '@apps-common/apis/management/unit-active'
import { QUERY_MANAGEMENT_GET_UNIT_CANCELLED } from '@apps-common/apis/management/unit-cancelled'
import { AppType } from '@apps-common/config/app-types'
import { QUERY_GET_UNIT_GENERIC_DETAILS } from '../apis/portal/unit/get-unit-generic-details'

export const invalidateGenericUnitQueries = async (unitId: string) =>
  Promise.all([await queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_GENERIC_DETAILS(unitId) })])

export const invalidateAllUnitQueries = async (unitId: string, type: AppType) => {
  if (type === 'management') {
    queryClient.invalidateQueries({ queryKey: QUERY_MANAGEMENT_GET_UNIT_ACTIVE(unitId) })
    queryClient.invalidateQueries({ queryKey: QUERY_MANAGEMENT_GET_UNIT_CANCELLED(unitId) })
    queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS() })
    queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS_COUNT() })
  } else {
    queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS() })
    queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS_COUNT() })
  }

  queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_GENERIC_DETAILS(unitId) })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_GET_PINNED_UNITS_LIST() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_ACTIVATION_LIST() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_PENDING_CANCEL_LIST() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_CANCELLED_LIST() })
}

export const removeAllUnitQueries = async (unitId: string, type: AppType) => {
  if (type === 'management') {
    queryClient.removeQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS() })
    queryClient.removeQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS_COUNT() })
  } else {
    queryClient.removeQueries({ queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS() })
    queryClient.removeQueries({ queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS_COUNT() })
  }

  queryClient.removeQueries({ queryKey: QUERY_GET_UNIT_GENERIC_DETAILS(unitId) })
  queryClient.removeQueries({ queryKey: QUERY_KEY_GET_PINNED_UNITS_LIST() })
  queryClient.removeQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_ACTIVATION_LIST() })
  queryClient.removeQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_PENDING_CANCEL_LIST() })
  queryClient.removeQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_CANCELLED_LIST() })
}

export const removeAllDashQueries = async () => {
  queryClient.removeQueries({ queryKey: QUERY_KEY_GET_PINNED_UNITS_LIST() })
  queryClient.removeQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_ACTIVATION_LIST() })
  queryClient.removeQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_PENDING_CANCEL_LIST() })
  queryClient.removeQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_CANCELLED_LIST() })
}
